/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* ==========================================================================
   Design System
   Utilities
   ========================================================================== */
.no-js .u-js-only {
  display: none !important;
}

.u-hide-if-js {
  display: none !important;
}
.no-js .u-hide-if-js {
  display: block !important;
}

.u-clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.u-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  border: 0;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

@media only all and (max-width: 37.5em) {
  .u-hide-on-mobile {
    display: none;
  }
}

.u-show-on-mobile {
  display: none;
}
@media only all and (max-width: 37.5em) {
  .u-show-on-mobile {
    display: block;
  }
}

.u-hidden {
  display: none !important;
}

.u-invisible {
  visibility: hidden;
}

.u-right {
  float: right;
}

.u-break-word {
  word-break: break-all;
}

.u-nowrap {
  white-space: nowrap;
}

/* stylelint-disable selector-class-pattern */
.u-flexible-container {
  /* stylelint-enable */
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
}
.u-flexible-container__inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.u-flexible-container--4-3 {
  /* stylelint-enable */
  position: relative;
  padding-bottom: 75%;
  height: 0;
}

/* stylelint-disable selector-class-pattern */
/* stylelint-enable */
.u-mt0 {
  margin-top: 0 !important;
}

.u-mb0 {
  margin-bottom: 0 !important;
}

.u-mt5 {
  margin-top: 5px !important;
}

.u-mb5 {
  margin-bottom: 5px !important;
}

.u-mt10 {
  margin-top: 10px !important;
}

.u-mb10 {
  margin-bottom: 10px !important;
}

.u-mt15 {
  margin-top: 15px !important;
}

.u-mb15 {
  margin-bottom: 15px !important;
}

.u-mt20 {
  margin-top: 20px !important;
}

.u-mb20 {
  margin-bottom: 20px !important;
}

.u-mt30 {
  margin-top: 30px !important;
}

.u-mb30 {
  margin-bottom: 30px !important;
}

.u-mt45 {
  margin-top: 45px !important;
}

.u-mb45 {
  margin-bottom: 45px !important;
}

.u-mt60 {
  margin-top: 60px !important;
}

.u-mb60 {
  margin-bottom: 60px !important;
}

.u-w100pct {
  width: 100%;
}

.u-w90pct {
  width: 90%;
}

.u-w80pct {
  width: 80%;
}

.u-w70pct {
  width: 70%;
}

.u-w60pct {
  width: 60%;
}

.u-w50pct {
  width: 50%;
}

.u-w40pct {
  width: 40%;
}

.u-w30pct {
  width: 30%;
}

.u-w20pct {
  width: 20%;
}

.u-w10pct {
  width: 10%;
}

.u-w75pct {
  width: 75%;
}

.u-w25pct {
  width: 25%;
}

.u-w66pct {
  width: 66.6666666667%;
}

.u-w33pct {
  width: 33.3333333333%;
}

/* stylelint-disable selector-class-pattern */
small,
.u-small-text {
  /* stylelint-enable */
  font-size: 0.875em;
}
small--subtle,
.u-small-text--subtle {
  color: var(--gray);
}